module.exports = __webpack_public_path__ + "fonts/Gibson-BoldItalic.48eca025.woff2";